import React, { useState } from 'react';
import { Button, Input, Card, Logo, Alert } from '../components/components';
import { PageContainer, Footer } from '../layout/layouts';
import { theme } from '../styles/theme';

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const handleReset = (e: React.FormEvent) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <PageContainer>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, padding: `${theme.spacing.xxl} 0` }}>
        <Logo size="lg" style={{ marginBottom: theme.spacing.xl }} />
        
        <Card style={{ width: '100%', maxWidth: '420px', padding: theme.spacing.lg }} hoverable={false}>
          <h2 style={{ margin: '0 0 8px 0', fontSize: theme.typography.fontSize.xl, color: theme.colors.textPrimary, textAlign: 'center' }}>
            Recover Access
          </h2>
          <p style={{ margin: `0 0 ${theme.spacing.lg} 0`, fontSize: theme.typography.fontSize.sm, color: theme.colors.textSecondary, textAlign: 'center' }}>
            We will dispatch a secure password reset link to your registered email address.
          </p>

          {sent ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.md }}>
              <Alert
                type="success"
                title="Recovery Email Dispatched"
                message={`Check your inbox at ${email} to complete the reset sequence.`}
              />
              <Button onClick={() => window.location.href = '/login'} fullWidth>
                Return to Login
              </Button>
            </div>
          ) : (
            <form onSubmit={handleReset} style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.md }}>
              <Input
                type="email"
                label="Registered Email Address"
                placeholder="founder@abcacademy.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <Button type="submit" fullWidth style={{ marginTop: theme.spacing.sm }}>
                Send Reset Link
              </Button>
            </form>
          )}

          <div style={{ textAlign: 'center', marginTop: theme.spacing.lg, fontSize: theme.typography.fontSize.xs, color: theme.colors.textSecondary }}>
            Remembered details? <a href="/login" style={{ color: theme.colors.primary, textDecoration: 'none', fontWeight: theme.typography.fontWeight.semibold }}>Go Back</a>
          </div>
        </Card>
      </div>
      <Footer />
    </PageContainer>
  );
};

export default ForgotPassword;
